export default function yaShare() {
    if (!document.getElementById('news-share')) return;

    let script = document.createElement('script');
    script.src = 'https://yastatic.net/share2/share.js';
    document.body.appendChild(script);

    setTimeout(() => {
        Ya.share2(document.getElementById('news-share'), { // eslint-disable-line
            content: {
                title: document.title,
                url: window.location.href
            }
        });
    }, 500)
}
